"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamResolutionConfiguration = exports.DefaultStreamerOptions = exports.StreamerResolutions = exports.Resolution = void 0;
var Resolution;
(function (Resolution) {
    Resolution["sxga"] = "SXGA   [1280x1024]";
    Resolution["hd"] = "HD     [1366x768]";
    Resolution["hdplus"] = "HDPLUS [1600x900]";
    Resolution["fhd"] = "FHD    [1920x1080]";
    Resolution["wuxga"] = "WUXGA  [1920x1200]";
    Resolution["qhd"] = "QHD    [2560x1440]";
    Resolution["wqhd"] = "WQHD   [3440x1440]";
    Resolution["uhd"] = "UHD    [3840x2160]";
})(Resolution = exports.Resolution || (exports.Resolution = {}));
exports.StreamerResolutions = {
    sxga: {
        x: 1280,
        y: 1024
    },
    hd: {
        x: 1366,
        y: 768
    },
    hdplus: {
        x: 1600,
        y: 900
    },
    fhd: {
        x: 1920,
        y: 1080
    },
    wuxga: {
        x: 1920,
        y: 1200
    },
    qhd: {
        x: 2560,
        y: 1440
    },
    wqhd: {
        x: 3440,
        y: 1440
    },
    uhd: {
        x: 3840,
        y: 2160
    }
};
exports.DefaultStreamerOptions = {
    iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
    iceTransportPolicy: 'all',
    bandwidth: {
        minBitrateKbps: 3000,
        maxBitrateKbps: 20000,
        startingBitrateKbps: 10000
    },
    audio: {
        maxAverageBitrateKbps: 128000,
        stereo: 1
    },
    forceRelay: false
};
/**
 * Returns resolution configuration based on the resolution name. The name should be one of the
 * following: sxga,hd,hdplus,fhd,wuxga,qhd,wqhd,uhd
 * @param resolutionName
 * @returns StreamResolutionConfiguration resolution configuration based onthe resolution name
 */
function streamResolutionConfiguration(resolutionName) {
    // Always default to fhd if not provided
    if (resolutionName === undefined) {
        resolutionName = Resolution.fhd;
    }
    // Non case sensitive
    resolutionName = resolutionName.toLocaleLowerCase();
    // We require that requested resolution name begins with one of the supported resolutions
    // If there is an extra description provided after we just strip it out and ignore it
    resolutionName = resolutionName.split(' ')[0];
    // If the resolution is not found just default to fhd
    if (exports.StreamerResolutions[resolutionName] === undefined) {
        resolutionName = Resolution.fhd;
    }
    const streamResolutionConfiguration = {
        maxWidth: exports.StreamerResolutions[resolutionName].x,
        maxHeight: exports.StreamerResolutions[resolutionName].y
    };
    return streamResolutionConfiguration;
}
exports.streamResolutionConfiguration = streamResolutionConfiguration;
